module.exports = __webpack_public_path__ + "img/about04.39812fbb.png";